/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function Service({ data }) {
  const { t } = useLanguage();

  return (
    <div className="border-t border-gray-200 pb-6" style={{ backgroundColor: "rgba(249,250,251,0.8)" }}>
      <div className="container mx-auto pt-20 pb-28">
        <Fade direction="right" triggerOnce>
          <h1 className="text-5xl text-black text-center font-bold">{t('servicesTitle')}</h1>
        </Fade>
        <Fade direction="left" triggerOnce>
          <p className="font-bold text-lg text-green-900 text-center mb-12">
            {t('servicesSubtitle')}
          </p>
        </Fade>

        <div className="grid grid-rows-3 px-10 gap-8 sm:grid-cols-3 sm:grid-rows-1 sm:gap-6 xl:gap-16">
          {
            data.map((item, index) => {
              // Get translation key based on index
              let titleKey = '';
              if (index === 0) titleKey = 'service1Title';
              else if (index === 1) titleKey = 'service2Title';
              else if (index === 2) titleKey = 'service3Title';
              
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Fade direction={item.animation} delay={500 * index} key={index} triggerOnce>
                  <div>
                    <div className="bg-white group rounded-2xl shadow-2xl border border-light-theme-purple transform transition duration-500 hover:scale-105">
                      <img src={item.imageUrl} alt="Service" className="w-full rounded-t-2xl" />
                      <h2 className="text-theme-blue text-center text-xl py-7 rounded-b-2xl">{t(titleKey)}</h2>
                    </div>
                  </div>
                </Fade>
              );
            })
          }
        </div>
      </div>
    </div>
  );
}
